
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18 3H6C3.79 3 2 4.78 2 6.97v10.06C2 19.22 3.79 21 6 21h12c2.21 0 4-1.78 4-3.97V6.97C22 4.78 20.21 3 18 3zM8.5 7.17c1.27 0 2.31 1.04 2.31 2.31s-1.04 2.31-2.31 2.31-2.31-1.04-2.31-2.31S7.23 7.17 8.5 7.17zm3.87 9.49c-.09.1-.23.16-.37.16H5c-.14 0-.28-.06-.37-.16a.52.52 0 01-.13-.38 3.548 3.548 0 013.19-3.17 8.66 8.66 0 011.61 0c1.68.16 3.03 1.49 3.19 3.17.02.14-.03.28-.12.38zm6.63.09h-2c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2c.41 0 .75.34.75.75s-.34.75-.75.75zm0-4h-4c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4c.41 0 .75.34.75.75s-.34.75-.75.75zm0-4h-5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h5c.41 0 .75.34.75.75s-.34.75-.75.75z","fill":"#B5B8B5"}})])
          )
        }
      }
    